/* src/app/features/honra/protocolo/solicitacao-honra-prioridade.component.scss */
#col-prioridadeOri {
  width: 15%;
}
#col-prioridadeNova {
  width: 15%;
}
#col-idOperacaoExterno {
  width: 28%;
}
#col-dataParcelaInicialASerHonrada {
  width: 13%;
}
/*# sourceMappingURL=solicitacao-honra-prioridade.component.css.map */
